module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 11-12ff1973b7f5a4ca4799fed0754f3dc3.jpg";